<template>
  <header>
    <!-- Faixa superior com degradê -->
    <div class="top-gradient-bar"></div>

    <div class="header-container">
      <!-- FLAGS - sozinhas no topo para mobile -->
      <div class="header-top" style="display: none;">
        <div class="flags">
          <img v-for="(flag, index) in flags" :key="index" :src="flag.src" :alt="flag.alt" class="flag" />
        </div>
      </div>

      <!-- CONTEÚDO PRINCIPAL - Desktop: logo/textos à esquerda, menus à direita -->
      <div class="header-content">
        <!-- LADO ESQUERDO - Logo e textos -->
        <div class="header-left">
          <!-- FLAGS - no topo da esquerda -->
          <div class="header-top">
            <div class="flags">
              <img v-for="(flag, index) in flags" :key="index" :src="flag.src" :alt="flag.alt" class="flag" />
            </div>
          </div>

          <!-- LOGO -->
          <div class="header-middle">
            <router-link to="/">
              <img :src="logoProjeto" alt="Logo Projeto" class="main-logo" />
            </router-link>
          </div>

          <!-- GRADIENTE + SUBTÍTULO -->
          <div class="header-bottom">
            <div class="top-gradient-bar2"></div>
            <h2 class="h2">{{ $t('main_title') }}</h2>
          </div>
        </div>

        <!-- MENUS (à direita no desktop) -->
        <div class="header-menus">
          <!-- Idiomas -->
          <nav class="language-switcher">
            <ul class="language-switcher-list">
              <li><button @click="setLocale('pt')">{{ $t('language_switcher_pt') }}</button></li>
              <li><button @click="setLocale('en')">{{ $t('language_switcher_en') }}</button></li>
              <li><button @click="setLocale('es')">{{ $t('language_switcher_es') }}</button></li>
              <li><button @click="setLocale('nl')">{{ $t('language_switcher_nl') }}</button></li>
            </ul>
          </nav>

          <!-- Navegação -->
          <nav class="nav">
            <ul>
              <li><router-link to="/#pae-como-fundamento">{{ $t('about') }}</router-link></li>
              <li><router-link to="/ToolsPage">{{ $t('tools') }}</router-link></li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import script from "./script.js";

export default script;
</script>

<style scoped src="./style.css"></style>